<div class="container" *ngIf="currentClient">

    <div class="row mb-2">
        <div class="display-flex flex-row align-items-center justify-content-between w-100">
            <label><strong>Application History For:</strong>
                {{ currentClient.prefix }} {{ currentClient.firstName }} {{ currentClient.middleInitial }} {{ currentClient.lastName }} {{ currentClient.suffix }}
            </label>
            <div *ngIf="hasAccess()" class="display-flex flex-column">
                <a [routerLink]="['../add', applicationType]" class="btn btn-primary mb-xs new-app-button"
                   [class.disabled]="!isClientValid()"
                   [title]="hasDraft ? 'A draft application exists. Complete or delete the draft first.' : ''">
                    New Application
                </a>
                <span *ngIf="invalidClientMessage && !isClientValid()"
                      class="text-danger">{{ invalidClientMessage }}</span>
            </div>
        </div>
    </div>
    <div *ngIf="clientDrafts?.length > 0" class="row mb-3">
        <div class="alert alert-warning w-100">
            <strong>Draft Applications</strong>
            <table class="table table-sm table-striped mt-2 mb-0">
                <thead class="header-border">
                    <tr>
                        <th>Created By</th>
                        <th>Created Date</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let draft of clientDrafts">
                        <td>{{ draft.createdByName }}</td>
                        <td>{{ draft.enteredDate | moment: 'L' }}</td>
                        <td>
                            <button class="btn btn-sm btn-primary me-1" (click)="editDraft(draft.id)">Edit</button>
                            <button class="btn btn-sm btn-danger" (click)="deleteDraft(draft.id)">Delete</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">
        <table class="table table-striped table-hover">
            <thead class="header-border">
            <tr>
                <th class="text-xs-center" (click)="sortTable('fundType.name')">
                    <div class="header-container">
                        <span class="header-label">Fund Type</span>
                        <div class="chevron-container">
                    <span *ngIf="sortField === 'fundType.name'; else notSortField">
                        <i *ngIf="sortDirection === 'asc'" class="fa fa-chevron-up"></i>
                        <i *ngIf="sortDirection === 'desc'" class="fa fa-chevron-down"></i>
                    </span>
                            <ng-template #notSortField>
                                <i class="fa fa-chevron-up"></i>
                                <i class="fa fa-chevron-down"></i>
                            </ng-template>
                        </div>
                    </div>
                </th>
                <th class="text-xs-center">
                    <div class="header-container">
                        <span class="header-label">Summary</span>
                    </div>
                </th>
                <th class="text-xs-center" (click)="sortTable('totalNeed')">
                    <div class="header-container">
                        <span class="header-label">Total Need</span>
                        <div class="chevron-container">
                    <span *ngIf="sortField === 'totalNeed'; else notSortField">
                        <i *ngIf="sortDirection === 'asc'" class="fa fa-chevron-up"></i>
                        <i *ngIf="sortDirection === 'desc'" class="fa fa-chevron-down"></i>
                    </span>
                            <ng-template #notSortField>
                                <i class="fa fa-chevron-up"></i>
                                <i class="fa fa-chevron-down"></i>
                            </ng-template>
                        </div>
                    </div>
                </th>
                <th class="text-xs-center" (click)="sortTable('assignedAgency.agencyName')">
                    <div class="header-container">
                        <span class="header-label">Agency</span>
                        <div class="chevron-container">
                    <span *ngIf="sortField === 'assignedAgency.agencyName'; else notSortField">
                        <i *ngIf="sortDirection === 'asc'" class="fa fa-chevron-up"></i>
                        <i *ngIf="sortDirection === 'desc'" class="fa fa-chevron-down"></i>
                    </span>
                            <ng-template #notSortField>
                                <i class="fa fa-chevron-up"></i>
                                <i class="fa fa-chevron-down"></i>
                            </ng-template>
                        </div>
                    </div>
                </th>
                <th class="text-xs-center" (click)="sortTable('createdByUser')">
                    <div class="header-container">
                        <span class="header-label">Case Manager</span>
                        <div class="chevron-container">
                    <span *ngIf="sortField === 'createdByUser'; else notSortField">
                        <i *ngIf="sortDirection === 'asc'" class="fa fa-chevron-up"></i>
                        <i *ngIf="sortDirection === 'desc'" class="fa fa-chevron-down"></i>
                    </span>
                            <ng-template #notSortField>
                                <i class="fa fa-chevron-up"></i>
                                <i class="fa fa-chevron-down"></i>
                            </ng-template>
                        </div>
                    </div>
                </th>
                <th class="text-xs-center" (click)="sortTable('status')">
                    <div class="header-container">
                        <span class="header-label">Case Status</span>
                        <div class="chevron-container">
                    <span *ngIf="sortField === 'status'; else notSortField">
                        <i *ngIf="sortDirection === 'asc'" class="fa fa-chevron-up"></i>
                        <i *ngIf="sortDirection === 'desc'" class="fa fa-chevron-down"></i>
                    </span>
                            <ng-template #notSortField>
                                <i class="fa fa-chevron-up"></i>
                                <i class="fa fa-chevron-down"></i>
                            </ng-template>
                        </div>
                    </div>
                </th>
                <th class="text-xs-center" (click)="sortTable('enteredDate')">
                    <div class="header-container">
                        <span class="header-label">Entry Date</span>
                        <div class="chevron-container">
                    <span *ngIf="sortField === 'enteredDate'; else notSortField">
                        <i *ngIf="sortDirection === 'asc'" class="fa fa-chevron-up"></i>
                        <i *ngIf="sortDirection === 'desc'" class="fa fa-chevron-down"></i>
                    </span>
                            <ng-template #notSortField>
                                <i class="fa fa-chevron-up"></i>
                                <i class="fa fa-chevron-down"></i>
                            </ng-template>
                        </div>
                    </div>
                </th>
                <th class="text-xs-center">
                    <div class="header-container">
                        <span class="header-label">Case ID</span>
                    </div>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let application of clientAssistanceApplications" (click)="navToDetail(application.id)"
                class="cursor-pointer">
                <td class="text-xs-center">{{application.fundPledgeTypeName}}</td>
                <td class="text-xs-center">{{application.summary}}</td>
                <td class="text-xs-center">{{application.totalNeed | parseNumber | currency:'USD':'symbol':'1.2-2'}}</td>
                <td class="text-xs-center">{{application.assignedAgency.agencyName}}</td>
                <td class="text-xs-center">{{application.createdByUser ? application.createdByUser.firstName + ' ' + application.createdByUser.lastName : 'None'}}</td>
                <td class="text-xs-center">{{getCaseStatus(application.status)}}</td>
                <td class="text-xs-center">{{application.enteredDate | moment: 'L'}}</td>
                <td class="text-xs-center">{{application.id}}</td>
            </tr>
            </tbody>
        </table>
    </div>

</div>
